﻿export const isUserApprovalStateUpToDate = (
  workflowHistory,
  { currentStepId } = {}
) => {
  const noWorkflowHistory = !workflowHistory?.length;

  if (noWorkflowHistory || !currentStepId) return false;

  return workflowHistory.some(({ id }) => id === currentStepId);
};
